import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useRBAC } from '../hooks/useRBAC';

/**
 * Wraps a route — redirects non-admins to the access-denied page.
 * Usage: <AdminRoute><AdminDashboard /></AdminRoute>
 */
export function AdminRoute({ children }) {
  const { isManager } = useRBAC();
  if (!isManager) return <AccessDenied />;
  return children;
}

/**
 * Full-page access denied screen shown when a salesperson
 * tries to navigate to an admin-only route.
 */
export function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4 animate-fade-in" data-testid="access-denied">
      <div className="w-20 h-20 rounded-2xl bg-destructive/10 flex items-center justify-center mb-6">
        <i className="fa-solid fa-shield-halved text-destructive text-3xl" />
      </div>
      <h2 className="font-heading text-2xl font-bold text-text-primary mb-2">Access Restricted</h2>
      <p className="text-text-muted text-sm max-w-sm mb-6">
        This section is only available to administrators. Contact your admin to request access or elevated permissions.
      </p>
      <div className="flex gap-3">
        <button
          onClick={() => navigate(-1)}
          className="btn-secondary text-sm"
          data-testid="go-back-btn"
        >
          <i className="fa-solid fa-arrow-left mr-1.5" />Go Back
        </button>
        <button
          onClick={() => navigate('/')}
          className="btn-primary text-sm"
          data-testid="go-dashboard-btn"
        >
          <i className="fa-solid fa-house mr-1.5" />Dashboard
        </button>
      </div>
    </div>
  );
}
